// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zILH","location":"Header_location__18dRW"};